import { normalizeHomeworld, type HOMEWORLDS } from '../server/identity';

type HomeworldName = (typeof HOMEWORLDS)[number];

export interface HomeworldBadge {
  name: HomeworldName;
  slug: string;
  col: number;
  row: number;
  accent: string;
}

const BADGES_BY_HOMEWORLD: Record<HomeworldName, HomeworldBadge> = {
  Tatoona: { name: 'Tatoona', slug: 'tatoona', col: 0, row: 0, accent: '#f5be67' },
  Nabuna: { name: 'Nabuna', slug: 'nabuna', col: 1, row: 0, accent: '#f7ad12' },
  Coruska: { name: 'Coruska', slug: 'coruska', col: 2, row: 0, accent: '#35c9f2' },
  Hothar: { name: 'Hothar', slug: 'hothar', col: 3, row: 0, accent: '#f2f7ff' },
  Endara: { name: 'Endara', slug: 'endara', col: 0, row: 1, accent: '#91bd55' },
  Bespira: { name: 'Bespira', slug: 'bespira', col: 1, row: 1, accent: '#f2a51f' },
  Mustara: { name: 'Mustara', slug: 'mustara', col: 2, row: 1, accent: '#f15a24' },
  Kashyra: { name: 'Kashyra', slug: 'kashyra', col: 3, row: 1, accent: '#8fac3d' },
  Kamira: { name: 'Kamira', slug: 'kamira', col: 0, row: 2, accent: '#78a8f2' },
  Dagova: { name: 'Dagova', slug: 'dagova', col: 1, row: 2, accent: '#9daa82' },
  Mandalora: { name: 'Mandalora', slug: 'mandalora', col: 2, row: 2, accent: '#aab0ba' },
  Jakkara: { name: 'Jakkara', slug: 'jakkara', col: 3, row: 2, accent: '#f08a17' },
};

export const HOMEWORLD_BADGES = Object.values(BADGES_BY_HOMEWORLD);

export function getHomeworldBadge(homeworld: string): HomeworldBadge {
  return BADGES_BY_HOMEWORLD[normalizeHomeworld(homeworld) as HomeworldName];
}

export function homeworldBadgeStyle(homeworld: string): string {
  const badge = getHomeworldBadge(homeworld);
  const x = badge.col === 0 ? 0 : (badge.col / 3) * 100;
  const y = badge.row === 0 ? 0 : (badge.row / 2) * 100;
  return `--homeworld-position-x:${x}%; --homeworld-position-y:${y}%; --homeworld-accent:${badge.accent};`;
}
